import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignRight } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { MenuItem } from '@chakra-ui/react';

export const RightAlignButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => {
            editor.chain().focus().setTextAlign('right').run();
         }}
         isDisabled={editor.isActive({ textAlign: 'right' })}
         icon={<FontAwesomeIcon icon={faAlignRight} size="lg" />}
         title={_js('Right Align')}
         iconSpacing={0}
      ></MenuItem>
   );
};
